import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import { notifyError, notifySuccess } from "utils/toast";
import { basicMarginServices } from "services/marginServices";

const defaultValues = {
  cityname: "",
  margin: {},
};

const useBasicMarginUpdateSubmit = (id) => {
  const {
    isDrawerOpen,
    closeDrawer,
    setIsUpdate,
  } = useContext(SidebarContext);

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [marginData, setMarginData] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const clearForm = () => {
    reset(defaultValues);
    clearErrors();
    setMarginData(null);
  };

const getMarginDetails = async () => {
  try {
    clearForm();

    const res = await basicMarginServices.getBasicMarginByCity(id);
    const marginInfo = res?.data;
    setMarginData(marginInfo);

    setValue("city_name", marginInfo?.city_name || "");

    Object.entries(marginInfo?.margin_details || {}).forEach(
      ([vehicleId, vehicle]) => {
        setValue(`margin.${vehicleId}`, vehicle.fee);
      }
    );
  } catch (err) {
    notifyError(
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong"
    );
  }
};

  const onSubmit = async (data) => {
    setLoading(true);
    setIsSubmitting(true);

    try {
      const margin = Object.entries(data.margin || {}).reduce(
        (acc, [key, value]) => {
          acc[key] = Number(value || 0);
          return acc;
        },
        {}
      );

      const payload = {
        margin,
      };

      const res = await basicMarginServices.updateBasicMarginByCity(
        id,
        payload
      );

      notifySuccess(res.message);

      setIsUpdate(true);

      closeDrawer();
    } catch (err) {
      notifyError(
        err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      clearForm();
      return;
    }

    if (id) {
      getMarginDetails();
    }
  }, [id, isDrawerOpen]);

  return {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    loading,
    isSubmitting,
    errors,
    marginData,
  };
};

export default useBasicMarginUpdateSubmit;